import { styled } from "srs.sharedcomponents/lib/esm/styles"

export const LinksBuilderContent = styled('div', {
    '[class*="builder"]': {
        position: 'initial !important'
    }
})